<template>
    <div class="table-row pricing-row">
        <div v-if="!showMobileVersion" class="td order-lg-0"></div>
        <div class="td text-truncate order-0 order-lg-1">
            <span class="mobile-title mr-2">Name:</span>
            <div class="text-truncate pr-4"
                 :title="name"
                 @click="goToCampPricing">
                {{ name }}
            </div>
        </div>
        <div class="td order-2 order-lg-2">
              <span v-if="schoolCountry === 'England'" class="mobile-title mr-2">Age/Years:</span>
            <span v-else class="mobile-title mr-2">Age/Grades:</span>
            {{ range }}
        </div>
        <div class="td order-3 order-lg-3"><span class="mobile-title mr-2">Time:</span>{{ formatTime(timeFrom) }} - {{ formatTime(timeTo) }}</div>
        <div class="td order-1 order-lg-4"><span class="mobile-title mr-2">Price:</span>{{ currencySign }} {{ price | priceFormat }}</div>
        <div class="td order-4 order-lg-5"><span class="mobile-title mr-2">Enrolled:</span>{{ enrolled }} / {{ maxEnroll }}</div>
        <div class="td order-5 order-lg-6">
            <span class="mobile-title mr-2">Status:</span>
            <activity-status :status="activityStatus"></activity-status>
        </div>
    </div>
</template>

<script>
    import * as moment from 'moment';
    import { mapGetters } from 'vuex';
    import * as Routes from '@/router/routes';
    import { AGES } from '@/constants/school-ages';
    import { GRADES } from '@/constants/school-grades';
    import { ResizeMobileMixin } from '@/mixins/ResizeMobileMixin';

    export default {
        name: 'CampPricingRow',
        components: {
            ActivityStatus: () => import('@/components/controls/ActivityStatus')
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            price: {
                type: Number,
                required: true
            },
            enrolled: {
                type: Number,
                required: true
            },
            maxEnroll: {
                type: Number,
                required: true
            },
            timeFrom: {
                type: String,
                required: true
            },
            timeTo: {
                type: String,
                required: true
            },
            gradeTo: {
                type: String
            },
            gradeFrom: {
                type: String
            },
            ageTo: {
                type: String
            },
            ageFrom: {
                type: String
            },
            daysList: {
                type: Array
            },
            activityStatus: {
                type: String
            },
        },
        mixins: [ResizeMobileMixin(992)],
        computed: {
            ...mapGetters(['currencySign', 'schoolCountry']),
            range() {
                let rangeFrom, rangeTo, type;
                if (this.gradeFrom) {
                    rangeFrom = GRADES.find(el => el.data === this.gradeFrom).view;
                    rangeTo = GRADES.find(el => el.data === this.gradeTo).view;
                    type = 'Grade';
                }
                else {
                    rangeFrom = AGES.find(el => el.data === this.ageFrom).view;
                    rangeTo = AGES.find(el => el.data === this.ageTo).view;
                    type = 'Age';
                }
                return rangeFrom === rangeTo ?
                    rangeFrom :
                    `${rangeFrom} - ${rangeTo}`;
            }
        },
        methods: {
            formatTime(time) {
                return moment(time, 'h:mm').format('hh:mm A');
            },
            goToCampPricing() {
                this.$router.push({
                    name: Routes.CAMP_ROSTERS,
                    params: {
                        id: this.id
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../assets/colors';
    @import '../../../../assets/mixins';

    @include table-tr-custom-mobile();

    .pricing-row {
        height: 60px;
        @media screen and (max-width: 991px) {
            height: auto;

            &:first-child {
                padding-top: 10px !important;
                border-top: 1px solid #e9edf0;
                border-radius: inherit;
            }
        }

        .td {
            display: flex;
            align-items: center;
            height: 100%;
            overflow: visible;
            &:nth-child(2) {
                font-weight: bold;
                font-size: 14px;
                color: $SoftBlue;
            }

            @media screen and (max-width: 991px) {
                justify-content: flex-start !important;

                &:first-child {
                    font-weight: bold;
                    font-size: 14px;
                    color: $SoftBlue;
                }
                &:nth-child(2) {
                    margin-bottom: 10px;
                    font-weight: normal;
                    color: inherit;
                }
                &:nth-child(4) {
                    font-weight: 600;
                    color: inherit;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camps/CampPricingRow.vue